<div mat-dialog-content class="cutom-dailog" [dir]="htmlDirection">
  <div class="container text-center px-0">
    @if (data.link) {
      <section-title>{{ 'It’s time to pay' | translate }}</section-title>
    }
    <img [src]="(data.src ? data.src : '/assets/flyplus/check.png') | assets" />
    <br />
    <h4>{{ data.successMsg | translate }}</h4>
    <p class="msg-body" innerHTML="{{ data.msgBody | translate }}"></p>
    @if (data.link) {
      <div class="input-group mb-4 link-form">
        <input
          type="text"
          class="form-control tracking-input"
          [value]="data.link"
          [placeholder]="'Link URL' | translate"
          #linkUrl
          disabled
        />
        <div class="input-group-append">
          <button
            mat-stroked-button
            color="primary"
            class="copy-button"
            (click)="copyUrl(data.link)"
            appTrackClick="creation-success-dialog-copy-link-btn"
          >
            <span translate>Copy</span>
          </button>
        </div>
      </div>
    }
    <div class="ahoy-secondary-divider m-row"></div>
    <div class="action-btns">
      @if (data.link) {
        <div>
          <a
            mat-flat-button
            color="primary"
            class="custom-btn"
            [href]="data.link"
            appTrackClick="creation-success-dialog-pay-now-btn"
            ctaType="primary"
          >
            {{ 'Pay Now' | translate }}
            <b
              ><currency-symbol [type]="data.currency"></currency-symbol>
              {{ data.price | numberTranslate }}</b
            >
          </a>
        </div>
      }
      @if (!data.link) {
        <button
          mat-flat-button
          class="custom-btn"
          color="primary"
          (click)="viewDetails()"
          appTrackClick="creation-success-dialog-view-details-btn"
        >
          <span translate>{{ data.buttonText }}</span>
        </button>
      }
    </div>
  </div>
</div>
